// Movie genres based on TMDB API
export const MOVIE_GENRES = [
  { id: 'all', name: 'Visi' },
  { id: '28', name: 'Veiksmo' },
  { id: '12', name: 'Nuotykių' },
  { id: '16', name: 'Animacijos' },
  { id: 'anime', name: 'Anime' },
  { id: '35', name: 'Komedijos' },
  { id: '80', name: 'Kriminalinis' },
  { id: '99', name: 'Dokumentinis' },
  { id: '18', name: 'Drama' },
  { id: '10751', name: 'Šeimos' },
  { id: '14', name: 'Fantastinis' },
  { id: '36', name: 'Istorinis' },
  { id: '27', name: 'Siaubo' },
  { id: '10402', name: 'Muzikinis' },
  { id: '9648', name: 'Misterija' },
  { id: '10749', name: 'Romantinis' },
  { id: '878', name: 'Mokslinė fantastika' },
  { id: '10770', name: 'TV filmas' },
  { id: '53', name: 'Trileris' },
  { id: '10752', name: 'Karo' },
  { id: '37', name: 'Vesternų' }
];

// TV show genres based on TMDB API
export const TV_GENRES = [
  { id: 'all', name: 'Visi' },
  { id: '10759', name: 'Veiksmo ir nuotykių' },
  { id: '16', name: 'Animacijos' },
  { id: 'anime', name: 'Anime' },
  { id: '35', name: 'Komedijos' },
  { id: '80', name: 'Kriminalinis' },
  { id: '99', name: 'Dokumentinis' },
  { id: '18', name: 'Drama' },
  { id: '10751', name: 'Šeimos' },
  { id: '10762', name: 'Vaikų' },
  { id: '9648', name: 'Misterija' },
  { id: '10763', name: 'Naujienų' },
  { id: '10764', name: 'Realybės' },
  { id: '10765', name: 'Mokslinės fantastikos' },
  { id: '10767', name: 'Pokalbių šou' }
];

// Movie sort options
export const MOVIE_SORT_OPTIONS = [
  { value: 'trending', label: 'Populiariausi' },
  { value: 'vote_average', label: 'Geriausiai įvertinti' },
  { value: 'revenue', label: 'Pelningiausi' }
];

// TV show sort options
export const TV_SORT_OPTIONS = [
  { value: 'trending', label: 'Populiariausi' },
  { value: 'vote_average', label: 'Geriausiai įvertinti' }
];

// Genre name mappings for display (used in cards and components)
export const GENRE_NAMES = {
  // Movie genres
  28: 'Veiksmo', 
  12: 'Nuotykių', 
  16: 'Animacijos', 
  35: 'Komedijos',
  80: 'Kriminalinis', 
  99: 'Dokumentinis', 
  18: 'Drama', 
  10751: 'Šeimos',
  14: 'Fantastinis', 
  36: 'Istorinis', 
  27: 'Siaubo', 
  10402: 'Muzikinis',
  9648: 'Misterija', 
  10749: 'Romantinis', 
  878: 'Mokslinė fantastika', 
  10770: 'TV filmas',
  53: 'Trileris', 
  10752: 'Karo', 
  37: 'Vesternų',
  
  // TV genres
  10759: 'Veiksmo ir nuotykių',
  10762: 'Vaikų',
  10763: 'Naujienų',
  10764: 'Realybės',
  10765: 'Mokslinės fantastikos',
  10766: 'Muilinės operos',
  10767: 'Pokalbių šou',
  10768: 'Karo ir politikos',
  anime: 'Anime'
};
